import { FC } from 'react';
import { Typography } from '@mui/material';
import { styled } from '@mui/material/styles';
import GradientAiIcon from 'components/icons/GradientAiIcon';
import { Row } from 'further-ui/components/Layout';

const IndicatorRow = styled(Row)(({ theme }) => ({
  padding: theme.spacing(0.25, 0),
  paddingLeft: theme.spacing(2),
}));

type Props = {
  label: string;
};

const ToolCallIndicator: FC<Props> = ({ label }) => (
  <IndicatorRow centered spacing="xs">
    <GradientAiIcon size={16} />
    <Typography variant="body2" color="text.disabled">
      {label}
    </Typography>
  </IndicatorRow>
);

export default ToolCallIndicator;
